import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LessonLearntCategory } from 'types/lessonLearnt';
import { WellPlanDTO } from 'types/wellPlan';

export type PerformanceState = Readonly<{
  wellPlans: WellPlanDTO[];
  lessonLearntAvailableCategories: LessonLearntCategory[];
}>;

export const initialState: PerformanceState = {
  wellPlans: [],
  lessonLearntAvailableCategories: [],
};

const performanceSlice = createSlice({
  name: 'Performance',
  initialState,
  reducers: {
    updateWellPlans: (state, action: PayloadAction<WellPlanDTO[]>) => {
      state.wellPlans = action.payload;
    },
    updateLessonLearntAvailableCategories: (
      state,
      action: PayloadAction<LessonLearntCategory[]>,
    ) => {
      state.lessonLearntAvailableCategories = action.payload;
    },
  },
});

export const { updateWellPlans, updateLessonLearntAvailableCategories } = performanceSlice.actions;
export default performanceSlice.reducer;
